import React from 'react';
import { CustomerIntelligenceData, getCourierIntelligence, isValidCustomerPhone } from './customerIntelligence';

interface SteadfastIntelligenceSummaryProps {
  customerHistory: CustomerIntelligenceData | null;
  loading: boolean;
  error?: string;
  phone: string;
  onViewDetails: () => void;
}

export const SteadfastIntelligenceSummary: React.FC<SteadfastIntelligenceSummaryProps> = ({
  customerHistory, loading, error, phone, onViewDetails,
}) => {
  if (!(phone || '').trim()) return null;

  const validPhone = isValidCustomerPhone(phone);
  const intelligence = getCourierIntelligence(customerHistory?.fraud_check?.steadfast);
  const statistics = intelligence.statistics;
  let text: string;
  if (!validPhone) text = 'Enter a valid Bangladesh mobile number (01XXXXXXXXX).';
  else if (loading) text = 'Checking Steadfast delivery history...';
  else if (error) text = `Steadfast unavailable: ${error}`;
  else if (!customerHistory) text = 'Steadfast delivery history is waiting to be checked.';
  else if (!statistics) text = `Steadfast unavailable: ${intelligence.message}`;
  else if (intelligence.status === 'no_history') text = 'Steadfast: No delivery history for this phone.';
  else text = `Steadfast: ${statistics.deliveryRate}% Success · ${statistics.returnRate}% Return rate${statistics.isHighRisk ? ' · High Return Risk' : ''}`;

  const hasError = validPhone && !loading && (!!error || (!!customerHistory && !statistics));
  const color = hasError ? '#92400e' : statistics?.isHighRisk ? '#b91c1c' : statistics?.isTrusted ? '#15803d' : '#475569';
  const counts = validPhone && !loading && !error && statistics
    ? `${statistics.delivered} delivered · ${statistics.cancelled} cancelled/returned · ${statistics.total} total`
    : '';

  return (
    <button
      type="button"
      onClick={onViewDetails}
      aria-label={`View Steadfast delivery intelligence. ${text}${counts ? ` ${counts}` : ''}`}
      style={{
        display: 'block', width: '100%', marginTop: '6px', padding: '7px 9px',
        border: `1px solid ${hasError ? '#fde68a' : statistics?.isHighRisk ? '#fecaca' : '#cbd5e1'}`,
        borderRadius: '7px', background: hasError ? '#fffbeb' : '#fff', color,
        textAlign: 'left', fontSize: '0.7rem', lineHeight: 1.5, cursor: 'pointer',
      }}
    >
      <span role="status" aria-live="polite">{text}</span>
      {counts && <span style={{ display: 'block' }}>{counts}</span>}
      <span style={{ display: 'block', marginTop: '2px', color: '#2563eb', fontWeight: 600 }}>View delivery intelligence</span>
    </button>
  );
};
